module.exports = __webpack_public_path__ + "img/Super_Shop_Logo_White.42ff52e4.svg";